/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SocialLinkDto } from '../models/SocialLinkDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicSocialLinksService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get social link by id (public)
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public getById1({
        id,
    }: {
        id: string,
    }): CancelablePromise<SocialLinkDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/v2/social-links/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get all social links by shopId (public)
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public getAllByShopId1({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<Array<SocialLinkDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/v2/social-links/shop/{shopId}/all',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get all social links (public)
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public getAll2(): CancelablePromise<Array<SocialLinkDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/v2/social-links/all',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
